/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQ.js.map